var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.taurusUpdated.length > 0
    ? _c(
        "md-list-item",
        {
          staticClass: "change-taid",
          on: {
            click: function($event) {
              _vm.isFormOpened = !_vm.isFormOpened
            }
          }
        },
        [
          _c("span", { staticClass: "md-list-item-text" }, [
            _vm._v(_vm._s(_vm.i18n.set_change_taid()))
          ]),
          _vm._v(" "),
          _c("md-icon", { staticClass: "md-icon--half-sized" }, [
            _vm._v("keyboard_arrow_right")
          ]),
          _vm._v(" "),
          _c(
            "md-dialog",
            {
              staticClass: "change-taid",
              attrs: {
                "md-active": _vm.isFormOpened,
                "md-click-outside-to-close": !_vm.isPending
              },
              on: {
                "update:mdActive": function($event) {
                  _vm.isFormOpened = $event
                },
                "update:md-active": function($event) {
                  _vm.isFormOpened = $event
                }
              }
            },
            [
              _vm.isPending
                ? _c("md-progress-bar", {
                    attrs: { "md-mode": "indeterminate" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("md-dialog-title", [
                _vm._v(_vm._s(_vm.i18n.set_change_taid()))
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "change-taid",
                  attrs: { novalidate: "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "app__dialog-inner" },
                    [
                      _vm.form.idx !== -1
                        ? _c("div", { staticClass: "label-select__actions" }, [
                            _c(
                              "label",
                              { staticClass: "label-select__caption" },
                              [_vm._v(_vm._s(_vm.i18n.lbl_auto_withdraw()))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.idx !== -1
                        ? [
                            _c(
                              "md-field",
                              [
                                _vm.taurusUpdated.length > 1
                                  ? _c(
                                      "md-select",
                                      {
                                        attrs: {
                                          name: "taid",
                                          label: _vm.i18n.lbl_taid()
                                        },
                                        model: {
                                          value: _vm.form.idx,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "idx", $$v)
                                          },
                                          expression: "form.idx"
                                        }
                                      },
                                      _vm._l(_vm.taurusUpdated, function(
                                        val,
                                        i
                                      ) {
                                        return _c(
                                          "md-option",
                                          {
                                            key: i,
                                            attrs: {
                                              value: i,
                                              selected: i === _vm.form.idx
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(val.id) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.taurusUpdated.length === 1
                                  ? _c(
                                      "div",
                                      { staticClass: "change-taid__item" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.taurusUpdated[0].id) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.form.idx !== -1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "auto-withdraw",
                                        on: { click: _vm.onAutoWithdraw }
                                      },
                                      [
                                        _vm.taurusUpdated[_vm.form.idx].auto
                                          ? _c(
                                              "md-icon",
                                              {
                                                staticClass:
                                                  "select-icon-size flex-end__item md-primary"
                                              },
                                              [_vm._v("check_box")]
                                            )
                                          : _c(
                                              "md-icon",
                                              {
                                                staticClass:
                                                  "select-icon-size flex-end__item"
                                              },
                                              [_vm._v("crop_3_2")]
                                            )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "md-dialog-actions",
                    { staticClass: "md-layout md-alignment-center-right" },
                    [
                      _vm.isUpdated
                        ? [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.isPending
                                }
                              },
                              [_vm._v(_vm._s(_vm.i18n.lbl_submit()))]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "button", disabled: _vm.isPending },
                          on: {
                            click: function($event) {
                              _vm.isFormOpened = !_vm.isFormOpened
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.i18n.lbl_close()))]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-671e5b53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-671e5b53","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/settings/security/Security.Taid.vue
// module id = W77T
// module chunks = 1